import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { AudioPlayerProvider } from '@lwtears/lwt-common-frontend/lib/AudioManager';

import store from '../store';

const AppProviders = (
  { children } //eslint-disable-line
) => (
  <ReduxProvider store={store}>
    <BrowserRouter>
      <AudioPlayerProvider useNativeAudioPlayer>{children}</AudioPlayerProvider>
    </BrowserRouter>
  </ReduxProvider>
);

export default AppProviders;
